import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useLabels, usePrefs } from 'wsm-common-data';
import { useLRUCache } from '../hooks/useLRUCache';
import { stateToSearchParams } from '../helpers';
import FetchReviewsProvider from '../providers/FetchReviewsProvider';
import ReviewContent from '../components/ReviewContent';

import '../global-sass/main.scss';
import Alert from '../components/Alert';

const WidgetContainer = () => {
	const { storeError, page, dealerId, reviews, reviewsInfo, reviewsFilters } =
		useSelector((state) => state);
	const label = useLabels();
	const { reviewsPerPage } = usePrefs();
	// initialize the cache with the current state
	const cache = useLRUCache(60, (set) => {
		const searchParams = stateToSearchParams(reviewsFilters, {
			page,
			vwDealerId: dealerId,
			maxSize: reviewsPerPage
		});
		set(`?${searchParams.toString()}`, {
			avgRating: reviewsInfo.avgRating,
			totalRatings: reviewsInfo.totalRatings,
			currentAvgRating: reviewsInfo.currentAvgRating,
			currentTotalRatings: reviewsInfo.currentTotalRatings,
			reviews
		});
	});
	if (storeError) {
		// eslint-disable-next-line no-console
		console.log('storeError', storeError);
		return <Alert type="danger">{label.get('SOMETHING_WENT_WRONG')}</Alert>;
	}

	return (
		<div className="ws-vw-reviews__container mx-5">
			<FetchReviewsProvider cache={cache}>
				<ReviewContent />
			</FetchReviewsProvider>
		</div>
	);
};

WidgetContainer.propTypes = {};

const mapStateToProps = (_state) => {
	return {};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
